import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";

const Table = () => {
  const [sortKey, setSortKey] = useState('profitability_ratio');
  const [sortOrder, setSortOrder] = useState('desc');
  const [sortedData, setSortedData] = useState([]);
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch('/data/profitability.json')
      .then(response => response.json())
      .then(data => setData(data))
      .catch(error => console.error(error));
  }, [])

  useEffect(() => {
    if (!data) {
      return setSortedData([]);
    }
    const sorted = [...data.profitability].sort((a, b) => {
      if (typeof a[sortKey] === 'string' && typeof b[sortKey] === 'string') {
        // Сравнение строк методом localeCompare
        return sortOrder === 'asc'
          ? a[sortKey].localeCompare(b[sortKey])
          : b[sortKey].localeCompare(a[sortKey]);
      } else {
        // Сравнение чисел операторами сравнения
        return sortOrder === 'asc'
          ? a[sortKey] - b[sortKey]
          : b[sortKey] - a[sortKey];
      }
    });
    setSortedData(sorted);
  }, [data, sortKey, sortOrder]);

  const handleSort = (key) => {
    if (key === sortKey) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortOrder('desc');
    }
  }

  if (!data) {
    return <div style={styles.loading}>Loading...</div>;
  }

  const date = new Date(data.timestamp);
  const localDate = date.toLocaleDateString();
  const localTime = date.toLocaleTimeString();

  return (<div style={styles.table}>
    <div style={styles.timestamp}>Update: {localDate} {localTime}</div>
    <div style={styles.headerRow}>
      <div onClick={() => handleSort('name')} style={styles.headerCell}>Name</div>
      <div onClick={() => handleSort('cost')} style={styles.headerCell}>Cost + $2.49</div>
      <div onClick={() => handleSort('predict_cost')} style={styles.headerCell}>Predict Cost</div>
      <div onClick={() => handleSort('difference')} style={styles.headerCell}>Predict Delta</div>
      <div onClick={() => handleSort('total_return')} style={styles.headerCell}>Return</div>
      <div onClick={() => handleSort('profitability_ratio')} style={styles.headerCell}>Profit (ROI)</div>
    </div>
    {sortedData.map((item, index) => (<div key={index} style={index % 2 === 0 ? styles.evenRow : styles.oddRow}>
      <div style={styles.cell}>
        <Link style={styles.link} state={{item: item}}
              to={"/case/" + item.name.replaceAll(' ', '-').toLowerCase()}>
          {item.name}
        </Link>
      </div>
      <div style={styles.cell}>${item.cost.toFixed(2)}</div>
      <div style={styles.cell}>${item.predict_cost.toFixed(2)}</div>
      <div style={styles.cell}>{item.difference.toFixed(2)}%</div>
      <div style={styles.cell}>${item.total_return.toFixed(2)}</div>
      <div style={styles.cell}>{item.profitability_ratio.toFixed(2)}%</div>
    </div>))}
  </div>);
};

const styles = {
  table: {
    display: 'flex', flexDirection: 'column', width: '100%',
  },
  loading: {
    textAlign: 'center',
  },
  timestamp: {
    textAlign: 'center',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#F5F5F5',
    fontSize: '14px',
    fontWeight: 'bold',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '10px 0px',
    textTransform: 'uppercase',
  },
  headerCell: {
    flex: 1, userSelect: 'none',
  },
  link: {textDecoration: 'none', color: 'blue'},
  cell: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    flex: 1,
    fontSize: '14px',
    padding: '10px 0px',
  },
  evenRow: {
    display: 'flex', flexDirection: 'row', backgroundColor: '#F9F9F9',
  },
  oddRow: {
    display: 'flex', flexDirection: 'row', backgroundColor: '#FFFFFF',
  },
};

export default Table;
